import {
  VALIDATE_MIGRATION,
  requestType,
  failedType,
  succeedType,
  MIGRATE_USER,
} from "./../actions/actionTypes";

const initState = {
  user_data: {},
  validating_migration: false,
  migrating_user: false,
  migration_message: "",
};

export const migrationReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(VALIDATE_MIGRATION):
      return {
        ...state,
        validating_migration: true,
      };
    case failedType(VALIDATE_MIGRATION):
      return {
        ...state,
        validating_migration: false,
        errMessage: action.errMessage,
      };
    case succeedType(VALIDATE_MIGRATION):
      return {
        ...state,
        validating_migration: false,
        user_data: action.user_data,
      };
    case requestType(MIGRATE_USER):
      return {
        ...state,
        migrating_user: true,
      };
    case failedType(MIGRATE_USER):
      return {
        ...state,
        migrating_user: false,
        errMessage: action.errMessage,
      };
    case succeedType(MIGRATE_USER):
      return {
        ...state,
        migrating_user: false,
        migration_message: action.migration_message,
      };
    default:
      return state;
  }
};
